import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';

import './select-account.scss';

import gazelleError from 'gazelle/src/components/error/error.module';
import gazelleErrorBar from 'gazelle/src/components/error-bar/error-bar.module';
import gazelleFormContent from 'gazelle/src/components/form-content/form-content.module';
import angularTranslate from 'angular-translate';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';

import * as selectAccount from './select-account.controller';

export default angular.module('account.devices.delete', [
  ngMaterial,
  uiRouter,
  gazelleError,
  gazelleErrorBar,
  gazelleFormContent,
  angularTranslate,
  gazelleAnalytics,
  'angulartics'
])
  .controller(selectAccount.name, selectAccount.default)
  .name;



// WEBPACK FOOTER //
// ./components/sign-in/select-account/select-account.module.js